import { render, staticRenderFns } from "./R_F7.vue?vue&type=template&id=585df8dd&scoped=true"
import script from "./R_F7.vue?vue&type=script&lang=js"
export * from "./R_F7.vue?vue&type=script&lang=js"
import style0 from "./R_F7.vue?vue&type=style&index=0&id=585df8dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585df8dd",
  null
  
)

export default component.exports